import { canUseDOM } from '@/app/common/utils/canUseDOM';
import type { COOKIE_KEY } from './types';

// Only a leading "www." becomes a shared ".domain"; any other host (qa-www.*, localhost) stays as-is —
// stripping "www" anywhere produced hosts like "qa-.lastminute.com", which browsers reject.
const getCookieDomain = () => document.location.hostname.replace(/^www\./, '.');

export const getCookie = (key: COOKIE_KEY): string | undefined => {
  if (!canUseDOM) return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
};

export const setCookie = (key: COOKIE_KEY, value: string, expireDays?: number) => {
  if (!canUseDOM) return;
  const domain = getCookieDomain();
  let cookieStr = `${key}=${encodeURIComponent(value)}; domain=${domain}; path=/`;
  if (expireDays != null) {
    const d = new Date();
    d.setTime(d.getTime() + expireDays * 864e5);
    cookieStr += `; expires=${d.toUTCString()}`;
  }
  document.cookie = cookieStr;
};

export const removeCookie = (key: COOKIE_KEY) => {
  if (!canUseDOM) return;
  const domain = getCookieDomain();
  document.cookie = `${key}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
